import React from 'react';
import { Switch, Modal } from 'antd';
import PropTypes from 'prop-types';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';

const MonetizeSwitch = ({ value: enableMonetization, onChange }) => {
  const intl = useIntl();

  const handleChange = async (enabled) => {
    if (enabled) {
      onChange(enabled);
    } else {
      Modal.confirm({
        title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
        content: intl.formatMessage({
          defaultMessage:
            'Turning off monetization means that ads/sponsorships will not run in this episode and you will not receive ad revenue.',
        }),
        onOk: () => {
          onChange(enabled);
        },
        onCancel: () => {},
        maskClosable: true,
      });
    }
  };

  return (
    <Switch
      checked={enableMonetization}
      onChange={handleChange}
      checkedChildren={<CheckOutlined />}
      unCheckedChildren={<CloseOutlined />}
    />
  );
};

MonetizeSwitch.propTypes = {
  setHasEnableMonetization: PropTypes.func,
  value: PropTypes.bool,
  onChange: PropTypes.func,
};

export default MonetizeSwitch;
